<template>
  <div>
    <div class="ws-textbox">
      <h2 class="ws-title">{{ langTransferWise['SFS_LANG_TRANSFER_WISE_1'] }}</h2>
      <p class="ws-text mt-1">{{ langTransferWise['SFS_LANG_TRANSFER_WISE_2'] }}</p>
      <div class="mb-2 mt-3">
        <p class="ws-title title-font-size mb-2">{{ langTransferWise['SFS_LANG_TRANSFER_WISE_3'] }}</p>
        <div class="d-flex">
          <div class="form-group w-100 d-flex">
            <select
              v-model="countryCode"
              class="form-control"
              name="currency"
              aria-label="Currency Select"
              @change="changeCountry()"
            >
              <option value="">{{ langTransferWise['SFS_LANG_TRANSFER_WISE_4'] }}</option>
              <option v-for="(item, k) in availableCountries" :key="k" :value="item.code">{{ item.name }}</option>
            </select>
          </div>
        </div>
      </div>
      <form v-show="checkBankCountry" @submit.prevent="updateBankInfo()">
        <div v-if="!isRevolutPayment">
          <div class="form-group mb-4">
            <label :for="'accountHolderName'" class="ws-title title-font-size mb-2">{{
              langTransferWise['SFS_LANG_TRANSFER_WISE_5']
            }}</label>
            <input
              id="accountHolderName"
              v-model="infoBank['accountHolderName']"
              :class="{ 'border-danger': error.accountHolderName }"
              class="form-control"
              type="text"
              :aria-label="langTransferWise['SFS_LANG_TRANSFER_WISE_5']"
            />
            <p v-if="error.accountHolderName && message.errorAccountHolderName" class="error">
              {{ message.errorAccountHolderName }}
            </p>
          </div>
          <div v-if="type == 'swift_code'">
            <div class="form-group mb-4">
              <label :for="'accountNumber'" class="ws-title title-font-size mb-2">{{
                langTransferWise['SFS_LANG_TRANSFER_WISE_14'] || 'IBAN / Account Number'
              }}</label>
              <input
                id="accountNumber"
                v-model="infoBank['accountNumber']"
                :class="{ 'border-danger': isAccountNumberNull }"
                class="form-control"
                type="text"
              />
              <p v-if="error.accountNumber" class="error">{{ message.errorIban }}</p>
            </div>
            <div class="form-group mb-4">
              <label :for="'swiftCode'" class="ws-title title-font-size mb-2">{{
                langTransferWise['SFS_LANG_TRANSFER_WISE_9'] || 'Swift Code'
              }}</label>
              <input
                id="swiftCode"
                v-model="infoBank['swiftCode']"
                :class="{ 'border-danger': isBankCodeNull }"
                class="form-control"
                type="text"
                :aria-label="langTransferWise['SFS_LANG_TRANSFER_WISE_9']"
              />
              <p v-if="error.swiftBic" class="error">{{ message.errorSwiftBic }}</p>
            </div>
            <div class="form-group mb-4">
              <label :for="country" class="ws-title title-font-size mb-2">{{
                langTransferWise['SFS_LANG_TRANSFER_WISE_10'] || 'Country'
              }}</label>
              <select
                id="country"
                v-model="infoBank['address.country']"
                :class="{ 'border-danger': errors.includes('address.country') }"
                class="form-control"
                :aria-label="langTransferWise['SFS_LANG_TRANSFER_WISE_10']"
              >
                <option :selected="true">{{ langTransferWise['SFS_LANG_TRANSFER_WISE_4'] }}</option>
                <option v-for="(item, k) in country" :key="k" :value="item.key">{{ item.name }}</option>
              </select>
            </div>
            <div class="form-group mb-4">
              <label :for="'city'" class="ws-title title-font-size mb-2">{{
                langTransferWise['SFS_LANG_TRANSFER_WISE_11'] || 'City'
              }}</label>
              <input
                id="city"
                v-model="infoBank['address.city']"
                :class="{ 'border-danger': errors.includes('address.city') }"
                class="form-control"
                type="text"
                :aria-label="langTransferWise['SFS_LANG_TRANSFER_WISE_11']"
              />
            </div>
            <div class="form-group mb-4">
              <label :for="'firstLine'" class="ws-title title-font-size mb-2">{{
                langTransferWise['SFS_LANG_TRANSFER_WISE_12'] || 'Recipient Address'
              }}</label>
              <input
                id="firstLine"
                v-model="infoBank['address.firstLine']"
                :class="{ 'border-danger': errors.includes('address.firstLine') }"
                class="form-control"
                type="text"
                :aria-label="langTransferWise['SFS_LANG_TRANSFER_WISE_12']"
              />
            </div>
            <div class="form-group mb-2">
              <label :for="'postCode'" class="ws-title title-font-size mb-2">{{
                langTransferWise['SFS_LANG_TRANSFER_WISE_13'] || 'Post Code'
              }}</label>
              <input
                id="postCode"
                v-model="infoBank['address.postCode']"
                :class="{ 'border-danger': errors.includes('address.postCode') }"
                class="form-control"
                type="text"
                :aria-label="langTransferWise['SFS_LANG_TRANSFER_WISE_13']"
              />
            </div>
          </div>
          <div v-else-if="type == 'iban'">
            <div class="form-group mb-2">
              <label :for="'iban'" class="ws-title title-font-size mb-2">{{
                langTransferWise['SFS_LANG_TRANSFER_WISE_6']
              }}</label>
              <input
                id="iban"
                v-model="infoBank['IBAN']"
                :class="{ 'border-danger': isIbanNull }"
                class="form-control"
                type="text"
                :aria-label="langTransferWise['SFS_LANG_TRANSFER_WISE_6']"
              />
              <p v-if="error.iban" class="error">{{ message.errorIban }}</p>
            </div>
          </div>
          <div v-else-if="type == 'email'">
            <div class="form-group mb-2">
              <label :for="'email'" class="ws-title title-font-size mb-2">Email</label>
              <input id="email" v-model="infoBank['email']" class="form-control" disabled type="text" :aria-label="'Email'" />
            </div>
          </div>
          <div v-else-if="type && currenMethodToPay?.fields.length">
            <div v-for="(item, key) in currenMethodToPay.fields" :key="key" class="form-group mb-2">
              <div v-if="item.group[0].required && item.group[0].key != 'legalType' && item.group[0].key != 'accountHolderName'">
                <label class="ws-title title-font-size mb-2">{{ getNameTranslated(item.group[0]) }}</label>
                <div v-if="item.group[0].type == 'select' || item.group[0].type == 'radio'">
                  <select
                    v-model="infoBank[item.group[0].key]"
                    :class="{ [item.group[0].key]: true, 'border-danger': errors.includes(item.group[0].key) }"
                    class="form-control"
                    :minlength="item.group[0].minLength"
                    :maxlength="item.group[0].maxLength"
                    :required="item.group[0].required"
                    :pattern="item.group[0].validationRegexp"
                    @change="
                      updateDataField(
                        $event,
                        item.group[0].validationAsync,
                        item.group[0].refreshRequirementsOnChange,
                        item.group[0].key
                      )
                    "
                  >
                    <option v-for="(valueAllowed, k) in item.group[0].valuesAllowed" :key="k" :value="valueAllowed.key">
                      {{ valueAllowed.name }}
                    </option>
                  </select>
                </div>
                <div v-else>
                  <input
                    v-model="infoBank[item.group[0].key]"
                    :class="{ 'border-danger': errors.includes(item.group[0].key) }"
                    class="form-control"
                    type="text"
                    aria-label="Bank info"
                  />
                  <p v-if="error.accountNumber && item.group[0].key === 'accountNumber'" class="error">
                    {{ message.errorAccountNumber }}
                  </p>
                  <p v-if="error.iban && item.group[0].key === 'IBAN'" class="error">{{ message.errorIbanAnother }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div>
            <div class="form-group mb-4">
              <label class="ws-title title-font-size mb-2">First Name</label>
              <input
                v-model="infoBank['first_name']"
                :class="{ 'border-danger': error.firstName }"
                class="form-control"
                type="text"
              />
              <p v-if="error.firstName" class="error">{{ message.firstName }}</p>
            </div>
            <div class="form-group mb-4">
              <label class="ws-title title-font-size mb-2">Last Name</label>
              <input
                v-model="infoBank['last_name']"
                :class="{ 'border-danger': error.lastName }"
                class="form-control"
                type="text"
              />
              <p v-if="error.lastName" class="error">{{ message.lastName }}</p>
            </div>
            <div v-for="(item, index) in fieldRevolutRequied" :key="index" class="form-group mb-4">
              <label class="ws-title title-font-size mb-2">{{ item.label }}</label>
              <input
                v-model="infoBank[item.parameter]"
                :class="{ 'border-danger': error[item.parameter] }"
                class="form-control"
                type="text"
              />
              <p v-if="error[item.parameter]" class="error">{{ message[item.parameter] }}</p>
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center justify-content-center mt-5">
            <button
              :class="currencyBank ? '' : 'avoid-click'"
              :disabled="!currencyBank"
              class="ws-btn hd-normal-btn-background-color hd-normal-btn-color"
              type="submit"
            >
              {{ langTransferWise['SFS_LANG_TRANSFER_WISE_7'] }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import { parsePhoneNumber } from '@/utils/variables'

export default {
  name: 'NewTransferWiseForm',
  props: {
    isNameNull: Boolean,
    isTypeIban: Boolean,
    wiseBankDetail: {
      type: Object,
      default: () => {}
    },
    langTransferWise: {
      type: Object,
      default: () => {}
    },
    excludeSaudiBankCountry: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      infoBank: {},
      countryCode: '',
      checkBankCountry: true,
      isIbanNull: false,
      inCorrectEmail: false,
      isRevolutPayment: false,
      country: [],
      receiverEmail: 'wise@strandedflightsolutions.com',
      iBanRegexp: '',
      accountNumberRegexp: '',
      nameRegexp: '',
      accountHolderNameRegexp: '',
      swiftBicRegexp: '',
      error: {
        accountHolderName: false,
        iban: false,
        accountNumber: false,
        swiftBic: false,
        bic: false,
        ifsc: false,
        routingNumber: false,
        bsbCode: false,
        clabe: false,
        sortCode: false,
        lastName: false,
        firstName: false
      },
      message: {
        errorAccountHolderName: '',
        errorIban: 'The bank details are incorrectly formatted, example: GB29NWBK60161331926819',
        errorIbanAnother: '',
        errorSwiftBic: 'Swift/Bic Code incorrectly formatted, example: METWAU4B',
        errorAccountNumber: 'The bank details are incorrectly formatted, example: 0621000449653',
        bic: 'The BIC Code incorrectly formatted, example: METWAU4B',
        ifsc: 'The IFSC Code incorrectly formatted',
        routingNumber: 'The Routing number incorrectly formatted',
        bsbCode: 'The BSB Code incorrectly formatted',
        clabe: 'The CLABE Code incorrectly formatted',
        sortCode: 'The Sort Code incorrectly formatted.',
        lastName: 'The last name field required',
        firstName: 'The first name field required'
      },
      isBankCodeNull: false,
      isAccountNumberNull: false,
      errors: [],
      fieldRevolutRequied: [],
      restrictedSaudiSelection: false
    }
  },
  computed: {
    ...mapGetters({
      Countrys: 'Refreshment/Countrys',
      dataBank: 'Refreshment/dataBank',
      dataInfoBankPax: 'Refreshment/dataInfoBankPax'
    }),
    type() {
      return this.currenMethodToPay?.type || ''
    },
    currenMethodToPay() {
      const typePriority = {
        iban: 2,
        swift_code: 1,
        email: -1
      }

      const paymentMethodsSorted = [...this.dataBank].sort((a, b) => {
        return (typePriority[b.type] || 0) - (typePriority[a.type] || 0)
      })

      return paymentMethodsSorted?.[0] || null
    },
    availableCountries() {
      if (!this.excludeSaudiBankCountry) {
        return this.Countrys
      }

      return this.Countrys.filter((country) => !this.isSaudiBankCountry(country.code))
    },
    countryBank() {
      return this.availableCountries.find((country) => country.code === this.countryCode)
    },
    currencyBank() {
      return this.countryBank?.currency_code || ''
    }
  },
  watch: {
    Countrys() {
      this.initData()
    },
    wiseBankDetail() {
      this.initData()
    }
  },
  mounted() {
    this.$store.dispatch('Refreshment/getListCountry')
    this.initData()
  },
  methods: {
    replaceStr,
    initData() {
      const preserveRestrictedSaudiSelection =
        this.excludeSaudiBankCountry && !this.wiseBankDetail && this.restrictedSaudiSelection
      this.restrictedSaudiSelection = preserveRestrictedSaudiSelection
      this.infoBank = {
        legalType: 'PRIVATE',
        accountHolderName: this.pax.full_name,
        first_name: this.pax.first_name,
        last_name: this.pax.last_name
      }

      if (this.wiseBankDetail) {
        this.infoBank = this.wiseBankDetail.params.details
        this.restrictedSaudiSelection = this.isSaudiBankCountry(this.infoBank.country)
        this.countryCode = this.restrictedSaudiSelection ? '' : this.infoBank.country
        if (this.Countrys && this.Countrys.length > 0 && !this.isSaudiBankCountry(this.infoBank.country)) {
          this.updateShowfield(true)
        }
      } else {
        if (this.Countrys && this.Countrys.length > 0) {
          this.autoSelectCountry()
        }
      }
    },
    getNameTranslated(item) {
      switch (item.key) {
        case 'address.country':
          return this.langTransferWise['SFS_LANG_TRANSFER_WISE_10']
        case 'address.city':
          return this.langTransferWise['SFS_LANG_TRANSFER_WISE_11']
        case 'address.firstLine':
          return this.langTransferWise['SFS_LANG_TRANSFER_WISE_12']
        case 'address.postCode':
          return this.langTransferWise['SFS_LANG_TRANSFER_WISE_13']
        default:
          return item.name
      }
    },
    errorAccountNumberMessage(accountNumber) {
      this.message.errorAccountNumber = 'The bank details are incorrectly formatted, example: ' + accountNumber
    },
    errorIbanAnother(ibanNumber) {
      this.message.errorIbanAnother = 'The bank details are incorrectly formatted, example: ' + ibanNumber
    },
    getBankCountry() {
      let data = {
        data: {
          country_code: this.countryCode,
          source: 'EUR',
          target: this.currencyBank,
          amount: 10
        },
        secret: this.$route.query.secret
      }
      this.$store.dispatch('Refreshment/changeCurrency', data).then((response) => {
        if (response.success) {
          let data = _.cloneDeep(response.data)
          this.isRevolutPayment = !!response.isRevolutPayment
          this.fieldRevolutRequied = response.fieldRevolutRequied
          if (!_.isEmpty(data)) {
            this.checkBankCountry = true
            return
          }
        }

        this.checkBankCountry = false
        this.$swal(
          this.langTransferWise['MESSAGE_COUNTRY_NOT_SUPPORT'] ||
            'Unfortunately it is not possible to transfer money to this country. Please use another bank account or go to the desk for support.'
        )
      })
    },
    autoSelectCountry() {
      if (this.countryCode === '') {
        const parsedPhoneNumber = parsePhoneNumber(this.pax?.phone_number)

        const countryCode = parsedPhoneNumber?.country || ''
        const isSaudiBankCountry = this.isSaudiBankCountry(countryCode)
        this.restrictedSaudiSelection = this.restrictedSaudiSelection || isSaudiBankCountry
        this.countryCode = isSaudiBankCountry ? '' : countryCode
      }

      this.$nextTick(() => {
        if (this.countryBank) {
          this.getBankCountry()
        }
      })
    },
    changeCountry() {
      if (this.restrictedSaudiSelection && this.countryBank) {
        this.restrictedSaudiSelection = false
      }

      if (this.countryBank) {
        this.getBankCountry()
      }
    },
    isSaudiBankCountry(countryCode) {
      return this.excludeSaudiBankCountry && typeof countryCode === 'string' && countryCode.toUpperCase() === 'SA'
    },
    isValidSwiftBic() {
      return new RegExp(this.swiftBicRegexp).test(this.infoBank.swiftCode)
    },
    isValidIban() {
      return new RegExp(this.iBanRegexp).test(this.infoBank.IBAN)
    },
    isValidAccountHolderName() {
      const regex = /^[a-zA-Z]{2,}\s[a-zA-Z]{2,}[a-zA-Z ]*$/
      return regex.test(this.infoBank.accountHolderName) && this.infoBank.accountHolderName.length <= 140
    },
    isValidAccountNumber() {
      return new RegExp(this.accountNumberRegexp).test(this.infoBank.accountNumber)
    },
    getRegexpOfTransferwise(key) {
      const transferwiseFields = this.currenMethodToPay?.fields || []

      return transferwiseFields.find((item) => item.group[0].key === key)
    },
    validationRevolutPayment() {
      // this regexNameFormat get from code js of sandbox revolut
      const regexNameFormat = /^[-\u2019'A-zÀ-ÿА-я ]{1,40}$/
      let isValid = true
      this.fieldRevolutRequied.forEach((field) => {
        if (new RegExp(field.regex.pattern).test(this.infoBank[field.parameter])) {
          this.error[field.parameter] = false
        } else {
          isValid = false
          this.error[field.parameter] = true
          this.message[field.parameter] = field.regex.explain
        }
      })
      if (!regexNameFormat.test(this.infoBank.first_name)) {
        isValid = false
        this.error.firstName = true
        this.message.firstName = 'Name can only include letters, hyphens and apostrophes (no more than 40 symbols)'
      } else {
        this.error.firstName = false
        this.message.firstName = ''
      }
      if (!regexNameFormat.test(this.infoBank.last_name)) {
        isValid = false
        this.error.lastName = true
        this.message.lastName = 'Name can only include letters, hyphens and apostrophes (no more than 40 symbols)'
      } else {
        this.error.lastName = false
        this.message.lastName = ''
      }
      return isValid
    },
    updateBankInfo() {
      let self = this
      if (this.restrictedSaudiSelection || this.isSaudiBankCountry(this.countryCode)) {
        return
      }

      if (self.isRevolutPayment) {
        if (self.validationRevolutPayment()) {
          const revolutPaymentInfo = {
            ...self.infoBank,
            first_name: self.infoBank.first_name,
            last_name: self.infoBank.last_name,
            currency: self.currencyBank,
            country: self.countryCode,
            bank_country: self.countryCode,
            bic: self.infoBank.bic,
            routing_number: self.infoBank.routingNumber,
            ifsc: self.infoBank.ifsc,
            clabe: self.infoBank.clabe,
            bsb_code: self.infoBank.bsbCode,
            sort_code: self.infoBank.sortCode,
            accountHolderName: self.infoBank.last_name + ' ' + self.infoBank.first_name
          }

          let infoPaxBank = {
            id: self.wiseBankDetail && self.wiseBankDetail.id ? self.wiseBankDetail.id : null,
            target: self.currencyBank,
            params: {
              isRevolutPayment: true,
              type: this.type,
              accountHolderName: self.infoBank.last_name + ' ' + self.infoBank.first_name,
              details: revolutPaymentInfo
            }
          }

          self.$emit('updateInfoPaxBank', infoPaxBank)
          return
        }

        return
      }

      this.resetValidationErrors()

      //get regular expression from transferwise
      const accountNumberRegexpTransferwise = this.getRegexpOfTransferwise('accountNumber') //type swift_code,[a-z,0-9] , example usa country
      const accountHolderNameRegexpTransferwise = this.getRegexpOfTransferwise('accountHolderName')
      const ibanRegexpTransferwise = this.getRegexpOfTransferwise('IBAN') //with type = iban , example germany country
      const swiftBicRegexpTransferwise = this.getRegexpOfTransferwise('swiftCode')

      this.isBankCodeNull = false
      this.isAccountNumberNull = false
      this.isIbanNull = false

      if (!_.isEmpty(accountHolderNameRegexpTransferwise) && !this.isValidAccountHolderName()) {
        this.error.accountHolderName = true
        let pattern = /^[a-zA-Z ]*$/
        if (pattern.test(this.infoBank.accountHolderName)) {
          this.message.errorAccountHolderName = 'Please input the valid account holder name'
        } else {
          this.message.errorAccountHolderName = 'The name can only consist out of Roman letters'
        }
        return
      }

      //validate theo type
      switch (self.type) {
        case 'iban':
          //validate blank iban , example country germany
          if (!self.infoBank.IBAN || self.infoBank.IBAN.trim() === '') {
            self.isIbanNull = true
            return
          }

          if (!_.isEmpty(ibanRegexpTransferwise)) {
            this.iBanRegexp = ibanRegexpTransferwise.group[0].validationRegexp
            if (!this.isValidIban() && !_.isEmpty(this.iBanRegexp)) {
              this.error.iban = true
              return
            }
          }
          break
        case 'swift_code':
          //validate account number blank,example usa country
          if (!self.infoBank.accountNumber || self.infoBank.accountNumber.trim() === '') {
            self.isAccountNumberNull = true
            return
          }
          if (!_.isEmpty(accountNumberRegexpTransferwise)) {
            this.accountNumberRegexp = accountNumberRegexpTransferwise.group[0].validationRegexp
            if (!this.isValidAccountNumber()) {
              this.error.accountNumber = true
              return
            }
          }
          //validate swiftcode, example usa country
          if (!self.infoBank.swiftCode || self.infoBank.swiftCode.trim() === '') {
            self.isBankCodeNull = true
            return
          }
          if (!_.isEmpty(swiftBicRegexpTransferwise)) {
            this.swiftBicRegexp = swiftBicRegexpTransferwise.group[0].validationRegexp
            if (!this.isValidSwiftBic()) {
              this.error.swiftBic = true
              return
            }
          }
          this.validateRequiredFields()
          break
        default:
          if (!_.isEmpty(ibanRegexpTransferwise) && !_.isUndefined(self.infoBank.IBAN)) {
            this.iBanRegexp = ibanRegexpTransferwise.group[0].validationRegexp
            if (!this.isValidIban() && !_.isEmpty(this.iBanRegexp)) {
              this.errorIbanAnother(ibanRegexpTransferwise.group[0].example)
              this.error.iban = true
              return
            }
          }
          this.validateRequiredFields()
          break
      }
      //validate loi chung
      if (!_.isEmpty(accountNumberRegexpTransferwise)) {
        if (!self.infoBank.accountNumber || self.infoBank.accountNumber.trim() === '') {
          self.isAccountNumberNull = true
          return
        }
        this.accountNumberRegexp = accountNumberRegexpTransferwise.group[0].validationRegexp
        if (!this.isValidAccountNumber() && !_.isEmpty(this.accountNumberRegexp)) {
          this.error.accountNumber = true
          //custom validate loi khi type khong phai iban,swiftcode
          if (this.type !== 'iban' && this.type !== 'swift_code') {
            this.errorAccountNumberMessage(accountNumberRegexpTransferwise.group[0].example)
          }
          return
        }
      }
      if (this.errors.length) return
      //end validate

      let infoBank = {
        legalType: 'PRIVATE',
        accountHolderName: self.infoBank.accountHolderName,
        country: self.countryCode
      }
      if (self.type === 'iban') {
        infoBank.IBAN = self.infoBank.IBAN
      } else if (self.type === 'swift_code') {
        infoBank.accountNumber = self.infoBank.accountNumber
        infoBank['address.country'] = self.infoBank['address.country']
        infoBank['address.city'] = self.infoBank['address.city']
        infoBank['address.firstLine'] = self.infoBank['address.firstLine']
        infoBank['address.postCode'] = self.infoBank['address.postCode']
        infoBank.swiftCode = self.infoBank.swiftCode
      } else if (self.type === 'email') {
        infoBank.email = self.infoBank.email
      } else {
        self.currenMethodToPay?.fields?.forEach(function (item) {
          if (item.group[0].required && item.group[0].key !== 'legalType' && item.group[0].key !== 'accountHolderName') {
            infoBank[item.group[0].key] = self.infoBank[item.group[0].key]
          }
        })
      }
      self.infoBank = infoBank
      let infoPaxBank = {
        id: self.wiseBankDetail && self.wiseBankDetail.id ? self.wiseBankDetail.id : null,
        target: self.currencyBank,
        params: {
          type: this.type,
          accountHolderName: self.infoBank.accountHolderName,
          details: self.infoBank
        }
      }

      this.$emit('updateInfoPaxBank', infoPaxBank)
    },
    resetValidationErrors() {
      // Set all values in this.error to false
      for (const key of Object.keys(this.error)) {
        this.error[key] = false
      }
    },
    validateRequiredFields() {
      const transferwiseFields = this.currenMethodToPay?.fields || []

      transferwiseFields.forEach((item) => {
        let group = item.group[0]
        let key = group.key
        let required = group.required
        if (!this.infoBank[key] && required) {
          this.errors.push(key)
        }
      })
    },
    updateShowfield(status) {
      if (!status) {
        return false
      }
      let self = this
      let data = {
        data: {
          source: 'EUR',
          target: self.currencyBank,
          amount: 10,
          form: {
            type: self.type,
            details: self.infoBank
          }
        },
        secret: this.$route.query.secret
      }
      self.$store.dispatch('Refreshment/updateDataField', data).then(() => {
        self.$forceUpdate()
      })
    },
    updateDataField(event, validationAsync, status, field) {
      let valueInput = event.target.value
      let self = this
      if (validationAsync) {
        let url = validationAsync.url + '?' + validationAsync.params[0].parameterName + '=' + valueInput
        self.$store.dispatch('Refreshment/checkValidator', url).then((res) => {
          if (!res.validation) {
            self.validateInfoBank[field] = res.errors[0].message
          } else {
            self.validateInfoBank[field] = null
          }
          self.$forceUpdate()
          self.updateShowfield(status)
        })
      } else {
        self.updateShowfield(status)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-font-size {
  font-size: 1.125rem;
}
.error {
  font-size: 13px;
  color: red;
  margin-top: 3px;
}
.upper-first-letter {
  text-transform: capitalize;
}
</style>
